import { observer } from 'mobx-react'
import React from 'react'
import MigrateTokensVM from './MigrateTokensVM'
import MigrationItem from './MigrationItem'
import OokiBalance from './OokiBalance'
import OokiMigrationInfo from './OokiMigrationInfo'

export function MigrateTokens({ vm }: { vm: MigrateTokensVM }) {
  return (
    <>
      <div>
        <div className="migration__banner" />
      </div>
      <div className="padded-h-2 flex-row-center justify-between margin-bottom-1">
        <h2 className="title-page txt-center">Migrate to OOKI</h2>
      </div>

      <div className="convert-token-grid margin-bottom-4">
        <OokiMigrationInfo vm={vm} />

        {vm.migrationStore.migrations.map((migration) => (
          <MigrationItem key={migration.details.id} vm={vm} migration={migration} />
        ))}

        <OokiBalance vm={vm} />
      </div>
    </>
  )
}

export default observer(MigrateTokens)
